import React, { createContext, useState, useContext } from 'react';

const ResultsContext = createContext();

const ResultsProvider = ({ children }) => {
  const [text, setText] = useState('');
  const [info, setInfo] = useState('');
  const [index, setIndex] = useState('tabelas');

  return (
    <ResultsContext.Provider
      value={{ text, setText, info, setInfo, index, setIndex }}
    >
      {children}
    </ResultsContext.Provider>
  );
};

function useResults() {
  const context = useContext(ResultsContext);

  return context;
}

export { ResultsProvider, useResults };
